module.exports = __webpack_public_path__ + "static/img/ortal.b6ec19f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/WhoAreWe/ortal.png
// module id = CtS2
// module chunks = 0